export default __webpack_public_path__ + "static/media/wnew1.f5afe890.png";